import React from 'react';
import WidgetSettingsNumericValueEditor from 'widgets/WidgetSettingsEditing/WidgetSettingsNumericValueEditor';

export interface WidgetConfigWithBucketSize {
    bucketSize: number;
}

export interface WidgetBucketSizeEditorProps {
    config: WidgetConfigWithBucketSize;
    onChange: (delta: Partial<WidgetConfigWithBucketSize>) => void;
}

export default function WidgetSettingsBucketSizeEditor(
    props: WidgetBucketSizeEditorProps
) {
    return (
        <WidgetSettingsNumericValueEditor
            className="bucket-size"
            label="Time Bucket"
            propertyName={'bucketSize'}
            min={1}
            max={120}
            {...props}
        />
    );
}
